<div class="main-view-container-loader">
  <img class="loading-spinner-icon" [src]="'assets/icons/loading.svg'" alt="">
  <div class="loading-text">Loading...</div>
</div>